import './Home.css'

const Privacy = () => {
    return (
        <div className="home">
            <div className="hero-background"></div>

            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="animate-slideUp stagger-1">
                            Privacy <span className="text-gradient">Policy</span>
                        </h1>
                        <p className="hero-subtitle animate-slideUp stagger-2">
                            Last Updated: December 31, 2025
                        </p>
                    </div>
                </div>
            </section>

            <section className="features">
                <div className="container">
                    <div className="glass-card" style={{ padding: '3rem', marginBottom: '4rem', lineHeight: '1.8' }}>
                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem' }}>1. Introduction</h2>
                        <p>At NAH44, your privacy is our priority. This Privacy Policy explains how we collect, use, and share information when you use our website, mobile application, and related services.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>2. Information We Collect</h2>
                        <div style={{ marginLeft: '1rem' }}>
                            <h3 style={{ fontSize: '1.2rem', color: 'white' }}>A. Personal Information</h3>
                            <p>When you register, we collect your name, email address, phone number, and vehicle details (for tag users) or business details (for franchise users).</p>

                            <h3 style={{ fontSize: '1.2rem', color: 'white', marginTop: '1rem' }}>B. Usage Data</h3>
                            <p>We automatically collect information about how you interact with our services, including IP addresses, device types, and system logs.</p>

                            <h3 style={{ fontSize: '1.2rem', color: 'white', marginTop: '1rem' }}>C. Scanning Data</h3>
                            <p>When a NAH44 tag is scanned, we may collect the location and time of the scan to facilitate communication and security.</p>
                        </div>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>3. How We Use Your Information</h2>
                        <p>We use the collected information to:
                            <ul>
                                <li>Provide and maintain our services.</li>
                                <li>Facilitate secure communication between vehicle owners and scanners.</li>
                                <li>Process payments for recharges and products.</li>
                                <li>Analyze usage patterns and improve user experience.</li>
                                <li>Send updates, security alerts, and support messages.</li>
                            </ul>
                        </p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>4. Data Sharing & Disclosure</h2>
                        <p>We do not sell your personal data. We may share information with:
                            <ul>
                                <li><strong>Service Providers:</strong> Third-party partners who help with payment processing, SMS delivery (MSG91/Twilio), WhatsApp, and cloud hosting.</li>
                                <li><strong>Legal Requirements:</strong> If required by law or to protect our rights and property.</li>
                                <li><strong>Business Transfers:</strong> In connection with a merger, sale, or acquisition.</li>
                            </ul>
                        </p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>5. Data Security</h2>
                        <p>We implement industry-standard security measures, including HTTPS/TLS encryption and secure password hashing, to protect your data. However, no method of transmission over the internet is 100% secure.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>6. Cookies & Tracking</h2>
                        <p>We use cookies to enhance your experience, remember your preferences, and track sessions. You can control cookie settings through your browser.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>7. Your Rights</h2>
                        <p>Depending on your location, you may have the right to access, correct, or delete your personal information. You can manage your profile settings through the NAH44 dashboard.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>8. Changes to This Policy</h2>
                        <p>We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the new policy on this page.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>9. Contact Information</h2>
                        <p>If you have questions about this Privacy Policy, please contact us at privacy@nah44.com.</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Privacy
